import { render, staticRenderFns } from "./ViIndividualSchoolView.vue?vue&type=template&id=32e47e69&scoped=true"
import script from "./ViIndividualSchoolView.vue?vue&type=script&lang=js"
export * from "./ViIndividualSchoolView.vue?vue&type=script&lang=js"
import style0 from "./ViIndividualSchoolView.vue?vue&type=style&index=0&id=32e47e69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e47e69",
  null
  
)

export default component.exports